import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import googleLogo from "../../assets/partner/google.svg";

const reviews = [
    {
        name: "Vincenzo S.",
        date: "Giugno 2025",
        rating: 5,
        text: "Voglio condividere la mia esperienza da cinque stelle presso il ristorante pizzeria il balconcino. Mi congratulo con Gianmarco, il proprietario della struttura e tutto il personale dello staff per la loro gentilezza, serietà e disponibilità per l’impeccabile servizio. Abbiamo vissuto un’esperienza eccellente, siamo rimasti colpiti da un ristorante pizzeria che unisce qualità, varietà e accoglienza in modo ineccepibile . Le pizze sono eccezionali, leggere e cotte alla perfezione, con ingredienti freschi e selezionati. Ma non solo: il menù offre tantissime proposte, tutte curate e ricche di sapore. Ce n’è davvero per tutti i gusti! Consigliatissimo per serate con amici.",
    },
    {
        name: "Fernanda",
        date: "Maggio 2025",
        rating: 5,
        text: "L'impasto della pizza è il migliore in assoluto nel raggio di 20 km. La salsa è ottima. Con questa base danno sempre il meglio. Tutti ragazzi giovani, molto gentili ed estremamente professionali e, come se non bastasse, i prezzi sono ottimi. Da non perdere!",
    },
    {
        name: "Antonio C.",
        date: "Maggio 2024",
        rating: 5,
        text: "Personale gentilissimo e pizza eccellente. Pizza molto leggera e con ingredienti di qualità. Anche gli antipasti sono sfiziosi noi abbiamo preso un tagliere veramente buono. Complimenti consiglio vivamente.",
    },
];

export default function CustomerReviews() {
    return (
        <section className="bg-background px-6 py-20 text-center max-w-6xl mx-auto relative">

            <motion.h2
                className="text-3xl font-title text-primary mb-12 tracking-tight"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                Cosa dicono i nostri clienti
            </motion.h2>

            <div className="grid gap-8 md:grid-cols-3">
                {reviews.map((review, idx) => (
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: idx * 0.2, duration: 0.4 }}
                        className="bg-surface border border-accent p-6 rounded-xl text-left shadow-lg hover:shadow-xl transition-shadow duration-300"
                    >
                        <div className="flex items-center gap-1 mb-3">
                            {Array.from({ length: review.rating }).map((_, i) => (
                                <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                            ))}
                        </div>
                        <p className="text-muted text-sm mb-4 leading-relaxed">"{review.text}"</p>
                        <div className="text-xs text-muted">
                            <strong>{review.name}</strong> — {review.date}
                        </div>
                    </motion.div>
                ))}
            </div>

            <div className="mt-12 flex items-center justify-center gap-3">
                <img src={googleLogo} alt="Recensioni Google" className="h-6" />
                <a
                    href="https://www.google.com/search?sa=X&sca_esv=301c2d72a545a3fe&tbm=lcl&sxsrf=AE3TifPU6c-n9eSeXMJXho_gER9IsMrPnw:1751294779600&q=Pizzeria+Il+Balconcino+Food+%26+Beer+Recensioni&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDG1MDE2MbYwMjM2trC0MDAwMN_AyPiKUTcgs6oqtSgzUcEzR8EpMSc5Py85My9fwS0_P0VBTcEpNbVIISg1OTWvODM_L3MRK2nqAbDEH257AAAA&rldimm=14584343826338980007&hl=it-IT&ved=2ahUKEwiYsvC5sZmOAxV2nf0HHZATC9kQ9fQKegQIVBAF&biw=1920&bih=934&dpr=1#lkt=LocalPoiReviews"
                    target="_blank"
                    rel="noreferrer"
                    className="text-muted text-sm hover:text-primary transition"
                >
                    Leggi tutte su Google
                </a>
            </div>
        </section>
    );
}